export const OFFER = 0;
export const ACCOUNT = 1;
export const BANK = 2;
export const BANK_ACCOUNT = 3;
export const BETFULLY_TRANSACTION = 4;
export const REWARD = 5;
export const FULL_TRANSACTION = 6;
export const REDEEMED_REWARD = 7;
